import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer data-scroll-section className="relative px-6 pt-20 pb-10 overflow-hidden theme-bg">
      <div
        className="absolute inset-x-0 bottom-0 top-[-40%] pointer-events-none"
        style={{
          backgroundImage: `
            radial-gradient(900px 520px at 20% 0%,
              color-mix(in oklab, var(--nt-primary) 32%, transparent) 0%,
              transparent 70%
            ),
            radial-gradient(900px 520px at 80% 0%,
              color-mix(in oklab, var(--brand-400) 24%, transparent) 0%,
              transparent 72%
            ),
            conic-gradient(from 180deg at 50% 22%,
              transparent 0deg,
              color-mix(in oklab, var(--nt-primary) 14%, transparent) 80deg,
              transparent 150deg,
              color-mix(in oklab, var(--brand-400) 10%, transparent) 240deg,
              transparent 360deg
            )
          `,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '140% 140%, 140% 140%, 120% 120%',
          animation: 'paladino-gradient-pan 12s ease-in-out infinite',
          maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.35) 55%, rgba(0,0,0,0) 100%)',
          WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.35) 55%, rgba(0,0,0,0) 100%)',
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="max-w-7xl mx-auto relative z-10"
      >
        <div className="w-full relative flex justify-center mb-24 overflow-hidden">
          <motion.h1
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="text-[12vw] md:text-[140px] font-semibold tracking-tighter select-none leading-[0.85] text-transparent bg-clip-text"
            style={{
              backgroundImage: `
                radial-gradient(180px 260px at 50% 10%, color-mix(in oklab, var(--brand-400) 55%, transparent) 0%, transparent 65%),
                linear-gradient(90deg,
                  color-mix(in oklab, var(--nt-primary) 92%, white 8%) 0%,
                  color-mix(in oklab, var(--brand-400) 70%, white 30%) 45%,
                  color-mix(in oklab, var(--nt-primary) 92%, white 8%) 100%
                )
              `,
              backgroundSize: '200% 200%',
              animation: ' 9s ease-in-out infinite',
            }}
          >
            PALADINO
          </motion.h1>
          <div
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full opacity-35 pointer-events-none"
            style={{
              background:
                'conic-gradient(from 180deg, transparent 0deg, color-mix(in oklab, var(--nt-primary) 22%, transparent) 120deg, transparent 220deg, color-mix(in oklab, var(--brand-400) 18%, transparent) 360deg)',
              filter: 'blur(38px)',
              animation: 'paladino-conic-spin 18s linear infinite',
            }}
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-10 gap-y-10">
          <div className="flex flex-col gap-3">
            <div className="text-[11px] font-semibold tracking-[0.18em] uppercase theme-text-muted">
              Funcionalidades
            </div>
            <div className="flex flex-col gap-2">
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Modelos</a>
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Agentes</a>
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Workflows</a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="text-[11px] font-semibold tracking-[0.18em] uppercase theme-text-muted">
              Produto
            </div>
            <div className="flex flex-col gap-2">
              <Link to="/register" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Integrações</Link>
              <Link to="/register" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Workflows</Link>
              <Link to="/register" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Preços</Link>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="text-[11px] font-semibold tracking-[0.18em] uppercase theme-text-muted">
              Legal e segurança
            </div>
            <div className="flex flex-col gap-2">
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Política de privacidade</a>
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Termos de uso</a>
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Segurança</a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="text-[11px] font-semibold tracking-[0.18em] uppercase theme-text-muted">
              Junte-se
            </div>
            <div className="flex flex-col gap-2">
              <Link to="/register" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Carreiras</Link>
              <a href="#" className="text-sm w-fit theme-text hover:text-[color:var(--nt-primary)] transition-colors">Contato</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t theme-border flex items-center justify-between gap-6">
          <div className="flex items-center gap-3 min-w-0">
            <img src="/logo-mini.svg" alt="Paladino Logo" className="h-7 w-7 opacity-90" />
            <span className="text-sm font-semibold tracking-wide theme-text truncate">Paladino</span>
          </div>
          <div className="text-xs theme-text-muted text-center flex-1">
            © 2026 Paladino AI. Todos os direitos reservados.
          </div>
          <div className="text-xs theme-text-muted min-w-[56px] text-right">
            pt-BR
          </div>
        </div>
      </motion.div>
    </footer>
  );
}
